<template>
    <div class="calculation-result">
        <h3 class="result-title">
            Let’s take a look at your numbers
        </h3>
        <p class="result-description">
            Keeping an eye on these amounts is a smart way to stay on top of things.
        </p>
        <div class="result-outer">
            <div class="calculation-output">
                <div class="calculation-output-inner">
                    <div class="calculation-title-wrapper">
                        <p class="calculation-title">
                            <img src="../../../assets/images/calendar-icon.svg" />
                            <span>Monthly Payment</span>
                        </p>
                    </div>
                    <h3 class="calculation-amount">
                        ${{ monthlyPaymentResult }}
                    </h3>
                </div>
                <p class="calculation-text">
                    Making on-time payments can go a long way towards building a healthy credit score.
                </p>
            </div>
            <div class="calculation-output">
                <div class="calculation-output-inner">
                    <div class="calculation-title-wrapper">
                        <p class="calculation-title">
                            <img src="../../../assets/images/personal-loan-icon.svg" />
                            <span>Total Interest</span>
                        </p>
                    </div>
                    <h3 class="calculation-amount">
                        ${{ totalInterestResult }}
                    </h3>
                </div>
                <p class="calculation-text total-repayment-text">
                    This means your total repayment amount would be <strong>${{ repaymentCalculation }}</strong>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';

    export default {
        props: ['monthlyPayment', 'totalInterest', 'propStudentLoanBalance', 'disclosureTokens', 'openDisclosureModal'],
        computed: {
            repaymentCalculation() {
                return Accounting.format(this.propStudentLoanBalance + this.totalInterest);
            },
            monthlyPaymentResult() {
                return Accounting.format(this.monthlyPayment);
            },
            totalInterestResult() {
                return Accounting.format(this.totalInterest);
            },
        },
    };
</script>
